import * as signalR from '@microsoft/signalr';
import vueAppSubfolder from '../utils/appSubfolderUtils';
import jwtDecode from 'jwt-decode';

class SignalRService {
	constructor() {
		this.connection = null;
		this.callbacks = [];
	}

	async startConnection() {
		try {
			let hubUrl =
				(vueAppSubfolder.get() === '/' ? '' : vueAppSubfolder.get()) +
				'/NotificationsModule/NotificationHub';
			let accessToken = localStorage.getItem('bearer');
			if (!accessToken) {
				console.error('No access token found in local storage.');
				return false;
			}
			let decodedJWT = jwtDecode(accessToken);
			let userId = decodedJWT.nameid;
			this.connection = new signalR.HubConnectionBuilder()
				.withUrl(hubUrl, {
					accessTokenFactory: () => localStorage.getItem('bearer'),
				})
				.withAutomaticReconnect()
				.build();

			// Set up the notification handler
			this.connection.on('ReceiveNotification', (message) => {
				this.callbacks.forEach((callback) => callback(message));
			});

			await this.connection.start();
			console.log('SignalR Connected.');

			// Register the user with the hub
			await this.connection.invoke('RegisterUser', userId);
			console.log(`User ${userId} registered with SignalR hub`);

			return true;
		} catch (error) {
			console.error('SignalR Connection Error: ', error);
			return false;
		}
	}

	onNotification(callback) {
		this.callbacks.push(callback);
	}

	async stopConnection() {
		if (this.connection) {
			await this.connection.stop();
			this.connection = null;
			this.callbacks = [];
		}
	}
}

export default new SignalRService();
